<template>
    <div style="background-color: rgb(251,251,251)">
        <home-header @getCity="getCity"></home-header>
        <div class="ticket_wrapper">
            <!-- 表单-->
            <img src="../assets/image/bg.jpg" alt="" style="width: 100%;">
            <div class="time_wrap">
                <div class="activity">
                    <p style="transform: rotate(90deg)">【</p>
                    <p>{{expoData.city_name}}站</p>
                    <p style="transform: rotate(90deg)">】</p>
                </div>
                <div class="r_activity">
                    <p class="time">{{expoData.date}}</p>
                    <p class="address text-overflow">{{expoData.address}}</p>
                </div>
            </div>
            <div class="form_wrap">
                <h3 class="mb10">免费索票</h3>
                <div class="tip mb10">
                    <!--                    <img src="../assets/image/home/form_icon.png" alt="">-->
                    <p>已有<span>32015</span>人索票</p>
                </div>
                <el-form :model="ruleForm" ref="ruleForm" class="ticket_form">
                    <el-form-item>
                        <el-input v-model="ruleForm.name" placeholder="您的姓名"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="ruleForm.phone" placeholder="您的电话"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <div class="submit_btn" @click="submitForm('ruleForm')">立即索票</div>
                    </el-form-item>
                </el-form>
                <div class="tips">
                    <b>展前须知：</b>
                    <span>网上报名立得价值30元的家庭套票，通过官方小程序"乐居家博会"领取</span>
                </div>
            </div>
        </div>
        <div class="wrap flow_wrap">
            <img src="../assets/image/home/flow.png" alt="流程" style="width: 100%;">
        </div>
        <div class="hr"></div>
        <!-- 活动排期-->
        <div class="activity_wrapper wrap">
            <template v-for="(item,index) in activity_img_list">
                <div :key="index" class="activity_item">
                    <img :src="item.thumb" alt="活动图" @click="clk_link(item.link)">

                    <p>时间：{{ item.date }}</p>
                    <p>地址：{{item.address}}</p>
                </div>
            </template>
        </div>
        <!-- 亮点-->
        <div class="wrap">
            <!-- title_img-->
            <img src="../assets/image/coms/brightdot.png" alt="亮点" class="title_img" v-if="bright_img_list.length > 0"/>
            <!-- list_img-->
            <div class="bright_wrapper mb60">
                <template v-for="(item,index) in bright_img_list">
                    <img :key="index" :src="item.thumb" @click="clk_link(item.link)"/>
                </template>
            </div>
        </div>
        <!-- 爆款-->
        <div class="wrap hot_sell">
            <img src="../assets/image/home/hot_title.png" alt="" class="title_img" v-if="sell_hot_img.length > 0"/>
            <div class="hot_sell_wrapper">
                <template v-for="(item,index) in sell_hot_img">
                    <div class="sell_hot_item" :key="index">
                        <img :src="item.thumb" alt="" @click="clk_link(item.link)"/>
                    </div>
                </template>
            </div>
        </div>
        <!-- 合作品牌-->
        <div class="wrap cooperate_wrapper">
            <img src="../assets/image/home/cooperate_title.png" alt="合作品牌" class="title_img"  v-if="cooperate_img.length > 0"/>
            <!--  cooperate_img-->
            <div v-for="(item, index) in cooperate_img">
                <img :key="index" :src="item.thumb" alt="" class="mb60" style="width: 100%;"/>
            </div>
        </div>

        <!-- 参展路线 dynamic-->
        <div class="wrap route_wrapper">
            <img src="../assets/image/home/route_title.png" alt="参展路线" class="title_img"/>
            <div class="route_detail mb60">
                <!--                        <img src="../assets/image/home/route_map.jpg" alt="地图" class="map_img"/>-->
                <div class="map_container" id="container"></div>

                <div class="right_route">
                    <h3>{{expoData.address}}</h3>
                    <div class="plan_item" v-if="expoData.transit">
                        <div class="title">
                            <p><img src="../assets/image/coms/bus.png"/>公交路线</p>
                        </div>
                        <p class="info">{{expoData.transit}}</p>
                    </div>
                    <div class="plan_item" v-if="expoData.metro">
                        <div class="title">
                            <p><img src="../assets/image/coms/subway.png"/>地铁路线</p>
                        </div>
                        <p class="info">{{expoData.metro}}</p>
                    </div>
                    <div class="plan_item" v-if="expoData.drive">
                        <div class="title">
                            <p><img src="../assets/image/coms/car.png"/>自驾路线</p>
                        </div>
                        <p class="info">{{expoData.drive}}</p>
                    </div>
                </div>
            </div>
        </div>
        <!-- 服务承诺-->
        <div class="wrap">
            <img src="../assets/image/home/promise_title.png" alt="服务承诺" class="title_img"/>
            <div class="promise_wrap">
                <img src="../assets/image/home/promise.png" alt="" style="width: 100%;">
            </div>
        </div>
        <!-- 底部-->
        <copyright></copyright>

        <!-- 报名成功-->
        <el-dialog
            :visible.sync="success_dialog"
            width="15%"
            center>
            <el-result icon="success" title="报名成功"></el-result>
        </el-dialog>
    </div>
</template>


<script>
    // 相关组件引入
    import HomeHeader from "../components/whiteheader";
    import copyright from "../components/copyright";
    import _regular from "../utils/_regular";
    import lib_website from "../libs/lib_website";

    export default {
        name: "Home",
        components: {
            HomeHeader,
            copyright
        },
        data() {
            return {
                ruleForm: {
                    name: '',
                    phone: '',
                },
                success_dialog: false, //成功弹框
                activity_img_list: [], // 排期
                bright_img_list: [], //亮点
                sell_hot_img: [], // 爆款
                cooperate_img: [], // 合作品牌
                expoData: {}, // 活动相关内容
                // 地图相关
                map: null, // 地图对象
            }
        },
        created() {
        },
        mounted() {


        },
        methods: {
            // 获取城市
            getCity(city) {
                lib_website.plan(this.init_plan)
                lib_website.ui(2, 4, this.init_expo)
                lib_website.ui(3, 6, this.init_product)
                lib_website.ui(4, 1, this.init_cooperate)
                lib_website.expo(this.init_expoData)
            },
            init_plan(data) {
                this.activity_img_list = data
            },
            // 图片链接
            clk_link(link) {

                if (link) {
                    window.location.href = link
                }
            },
            init_expo(data) {
                this.bright_img_list = data
            },
            init_product(data) {
                this.sell_hot_img = data
            },
            init_cooperate(data) {
                this.cooperate_img = data
            },
            init_expoData(data) {
                this.expoData = data

                this.mapInit()
            },


            // 初始化地图
            mapInit() {

                let lat = Number(this.expoData.latitude)
                let lng = Number(this.expoData.longitude)

                try {
                    if (this.map){
                        this.map.destroy()
                    }
                } catch (e) {

                }

                // 在页面渲染完成后进行地图的实例化
                this.$nextTick(() => {

                    //定义地图中心点坐标
                    let center = new TMap.LatLng(lat, lng)
                    //定义map变量，调用 TMap.Map() 构造函数创建地图
                    this.map = new TMap.Map(document.getElementById('container'), {
                        center: center,//设置地图中心点坐标
                        zoom: 17,   //设置地图缩放级别
                        // pitch: 43.5,  //设置俯仰角
                        // rotation: 45    //设置地图旋转角度
                    });

                })
            },

            submitForm(formName) {
                // 校验
                if (!this.ruleForm.name) {
                    this.$message.info('请输入您的姓名');
                    return
                }
                if (this.ruleForm.name && this.ruleForm.name.length > 20) {
                    this.$message.info('请输入您正确的姓名');
                    return
                }
                if (!this.ruleForm.phone) {
                    this.$message.info('请输入您的电话');
                    return;
                }
                if (!_regular.is_mobile(this.ruleForm.phone)) {
                    this.$message.info('请输入正确的电话');
                    return;
                }

                let that = this;
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        // 发起请求
                        lib_website.clue(that.expoData.expo_id, that.ruleForm.phone,that.ruleForm.name, function (data) {
                            that.success_dialog = true
                            setTimeout(()=>{
                                // 清空
                                that.success_dialog = false
                                that.ruleForm = {}
                            },1000)
                        })

                    }
                });
            },
        }
    };
</script>
<style scoped lang="less">
    @import "../assets/style/pages/home.less";

</style>

<style lang="less" scoped>
    .ticket_form /deep/ .el-form-item {
        margin-bottom: 10px;

        .el-input__inner {
            height: 45px;
            line-height: 45px;
        }
    }

    .submit_btn {
        width: 100%;
        background-color: red;
        color: #fff;
        font-size: 18px;
        letter-spacing: 2px;
        font-weight: bold;
        height: 45px;
        line-height: 45px;
        border-radius: 5px;
    }
    /deep/ .el-dialog{
        border-radius: 15px;
    }

</style>
